import React, { memo } from 'react';
import SidebarItem from './SidebarItem';
import ThemeToggle from '../../common/ThemeToggle';
import styles from './Sidebar.module.css';

const navigationItems = [
  {
    id: 'projects',
    label: 'Projects',
    icon: 'dashboard',
    description: 'Manage TARA projects'
  },
  // Architecture diagrams are accessed per-project via the workspace
  // tab (/project/:projectId/architecture), not from the top-level
  // sidebar — removed to avoid landing users on a sessionless page.
  {
    id: 'library',
    label: 'Library',
    icon: 'library',
    description: 'Reusable TARA entities'
  },
  {
    id: 'vulnerability-management',
    label: 'Vulnerability Management',
    icon: 'shield',
    description: 'Manage SBOM vulnerabilities'
  },
  {
    id: 'document-assessment',
    label: 'Document Assessment',
    icon: 'checklist',
    description: 'Find ISO 21434 gaps in your existing TARA documents'
  }
  // `integrations` and `admin-configuration` entries removed by DC-001 +
  // FU-002A — both pointed at top-level Athena routes that have been
  // retired. Both surfaces are now reachable only as per-project workspace
  // tabs.
];

const Sidebar = memo(({ expanded, activeItem, onNavigation, onExpandedChange }) => {
  const handleMouseEnter = () => {
    onExpandedChange(true);
  };

  const handleMouseLeave = () => {
    onExpandedChange(false);
  };

  return (
    <nav 
      className={`${styles.sidebar} ${expanded ? styles.expanded : ''}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      role="navigation"
      aria-label="Main navigation"
    >
      <div className={styles.sidebarContent}>
        <div className={styles.logo}>
          <div className={styles.logoIcon}>
            <img src="/athena-logo.png" alt="Athena Logo" className={styles.logoImg} />
          </div>
          {expanded && (
            <span className={styles.logoText}>Athena</span>
          )}
        </div>

        <div className={styles.navigation}>
          {navigationItems.map((item, index) => (
            <SidebarItem
              key={item.id}
              item={item}
              isActive={activeItem === item.id}
              expanded={expanded}
              index={index}
              onClick={() => onNavigation(item.id)}
            />
          ))}
        </div>

        <div className={styles.sidebarFooter}>
          {expanded && (
            <ThemeToggle variant="button" />
          )}
          <div className={styles.statusIndicator}>
            <div className={styles.statusDot} />
            {expanded && (
              <span className={styles.statusText}>System Online</span>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
});

Sidebar.displayName = 'Sidebar';

export default Sidebar;